import axios from 'axios'
import { AbstractService } from "@/services/nextshop/abstract.service";
import { AuthService } from '@/services/auth.service';
import $store from "@/state/store"
import { BIconTelephoneForward } from 'bootstrap-vue';
export class ItemService extends AbstractService {
  static get entityUnit() {
    return "nsh/item-extra/api/item-unit/";
  }

  static get entityBrand() {
    return "nsh/item-extra/api/item-brand/";
  }

  static get entityWarranty() {
    return "nsh/item-extra/api/item-warranty/";
  }

  static get entityInventory() {
    return "nsh/inventory/api/inventory-item/";
  }

  static get entityUpc() {
    return "items/upc"
  }

  static get entityUpdateUpc() {
    return "items/upcs"
  }

  static get entityBatch() {
    return "proxy-gateway/gw-core/product-batch/"
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  static async getListUnit(_params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/${this.entityUnit}list`,
        _params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async createUnit(_params) {
    try {
      const response = await this.callApi().post( 
        `${this.URL_GATEWAY}/${this.entityUnit}create`,
        _params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async deleteUnit(_params) {
    try {
      const response = await this.callApi().post( 
        `${this.URL_GATEWAY}/${this.entityUnit}delete`,
        _params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async updateUnit(_params) {
    try {
      const response = await this.callApi().post( 
        `${this.URL_GATEWAY}/${this.entityUnit}update`,
        _params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getListBrand(_params) {
    try {
      const response = await this.callApi().post( 
        `${this.URL_GATEWAY}/${this.entityBrand}list`,
        _params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async createBrand(_params) {
    try {
      const response = await this.callApi().post( 
        `${this.URL_GATEWAY}/${this.entityBrand}create`,
        _params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async updateBrand(_params) {
    try {
      const response = await this.callApi().post( 
        `${this.URL_GATEWAY}/${this.entityBrand}update`,
        _params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async deleteBrand(_params) {
    try {
      const response = await this.callApi().post( 
        `${this.URL_GATEWAY}/${this.entityBrand}delete`,
        _params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getListWarranty(_params) {
    try {
      const response = await this.callApi().post( 
        `${this.URL_GATEWAY}/${this.entityWarranty}list`,
        _params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async createWarranty(_params) {
    try {
      const response = await this.callApi().post( 
        `${this.URL_GATEWAY}/${this.entityWarranty}create`,
        _params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async updateWarranty(_params) {
    try {
      const response = await this.callApi().post( 
        `${this.URL_GATEWAY}/${this.entityWarranty}update`,
        _params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async deleteWarranty(_params) {
    try {
      const response = await this.callApi().post( 
        `${this.URL_GATEWAY}/${this.entityWarranty}delete`,
        _params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async checkInInventory(params) {
    try {
      const response = await this.callApi().post( 
        `${this.URL_GATEWAY}/${this.entityInventory}checkin`,
        params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async editInventory(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY}/${this.entityInventory}change-quantity`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-app-id": process.env.VUE_APP_ID,
            "np-location-id": $store.state.auth.currentLocation
          }
        }
      )
      return response.data
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async genBarcode(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/nsh/item/${this.entityUpc}`, params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }

  static async updateBarcode(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/nsh/item/${this.entityUpdateUpc}`, params
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }

  static async getBatchData(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/${this.entityBatch}search-and-sort-multiple`, params
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }

  static async getBatchDetail(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/${this.entityBatch}batch-detail`, params
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }

  static async updateBatchDetail(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/${this.entityBatch}update`, params
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }

  static async getBatchHistory(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/nsh/odm/api/order/so/show-history`, params
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  } 
} 